import styled from 'styled-components';
import { Flex, FlexProps } from '../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'FileLoadingNotification' })
    .attrs<FlexProps>({
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        width: { xs: 'calc(100% - 32px)', sm: 'auto' },
        zIndex: '10000',
        direction: 'row',
        alignItems: 'center',
        spacing: { xs: 2, sm: 4 },
        p: 2,
        borderRadius: 2,
        background: 'var(--background-invert)',
        boxShadow: '0 8px 20px 0 rgba(0, 0, 0, 0.4)',
    })``;
